import type { CreateSupportTicketTeamEnum } from 'api';

import { teamRequestCategoryMap } from './options';

interface Option {
  label: string;
  value: string;
}

export const getTeamRequestCategories = (team: CreateSupportTicketTeamEnum): Option[] => {
  const newOptions = teamRequestCategoryMap.get(team);

  if (!newOptions) {
    return [];
  }

  return newOptions.map((option: string) => ({
    label: option,
    value: option,
  }));
};
